module.exports = __webpack_public_path__ + "img/daniele-pro.43666842.jpg";